import SegmentEventTypes from 'scripts/redux/actions/segment/SegmentEventTypes';
import { track } from 'src/tracking/analytics';

export function sendLinkClickEvent({ from, title, located }) {
  return track(SegmentEventTypes.CLICK, { 'From': from, 'Title': title, 'Located': located });
}
